import "@/App.css";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App min-h-screen bg-[#050505] text-white">
      <Landing />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
